import { createAsyncAction } from 'typesafe-actions';
import { GlossaryDataType } from '@rootCommon/types/glossary';
import { GlossaryPayload } from '@rootCommon/constants/glossaries';
import { GlossaryData } from '@reducers/glossary';

const fetchGlossaryData = createAsyncAction(
  'FETCH_GLOSSARY_DATA_REQUEST',
  'FETCH_GLOSSARY_DATA_SUCCESS',
  'FETCH_GLOSSARY_DATA_FAILURE',
)<GlossaryPayload, { type: GlossaryPayload; data: GlossaryDataType[] }, Error>();

const fetchGlossariesData = createAsyncAction(
  'FETCH_GLOSSARIES_DATA_REQUEST',
  'FETCH_GLOSSARIES_DATA_SUCCESS',
  'FETCH_GLOSSARIES_DATA_FAILURE',
)<GlossaryPayload[], GlossaryData, Error>();

export { fetchGlossaryData, fetchGlossariesData };
